import { withI18n } from 'panda-i18n';
import locale from "../../locales";
import { OSSImageUpload } from './oss-image-upload';
export var CnOSSImageUpload = withI18n(OSSImageUpload, {
    locale: locale,
    // 此处不要删除，特意为了国际化使用了小写的 Oss
    componentName: 'CnOssImageUpload',
});
CnOSSImageUpload.displayName = 'CnOSSImageUpload';
